import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ToastProvider } from './components/ui';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Campus from './pages/Campus';
import Classes from './pages/Classes';
import Students from './pages/Students';
import Teachers from './pages/Teachers';
import Users from './pages/Users';
import UserPermissions from './pages/UserPermissions';
import Attendance from './pages/Attendance';
import Payments from './pages/Payments';
import Activities from './pages/Activities';
import StaffActivity from './pages/StaffActivity';
import Notifications from './pages/Notifications';
import Reports from './pages/Reports';
import Payroll from './pages/Payroll';
import MyPayroll from './pages/MyPayroll';
import Layout from './components/Layout';
import { useAuth } from './contexts/AuthContext';

const TeacherAssistantRestrictedRoute = ({ children }: { children: React.ReactNode }) => {
    const { user } = useAuth();

    if (user?.role === 'TEACHER' || user?.role === 'ASSISTANT') {
        return <Navigate to="/attendance" replace />;
    }

    return <>{children}</>;
};

// Pay data is for admins only; everyone else lands on their own payroll page.
const AdminOnlyRoute = ({ children }: { children: React.ReactNode }) => {
    const { user } = useAuth();

    if (user?.role !== 'ADMIN') {
        return <Navigate to="/my-payroll" replace />;
    }

    return <>{children}</>;
};

function App() {
    return (
        <AuthProvider>
            <ToastProvider>
                <div className="min-h-screen bg-transparent">
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="/*"
                            element={
                                <ProtectedRoute>
                                    <Layout>
                                        <Routes>
                                            <Route path="/" element={<Navigate to="/attendance" replace />} />
                                            <Route path="/dashboard" element={<Dashboard />} />
                                            <Route path="/campuses" element={<TeacherAssistantRestrictedRoute><Campus /></TeacherAssistantRestrictedRoute>} />
                                            <Route path="/classes" element={<Classes />} />
                                            <Route path="/students" element={<Students />} />
                                            <Route path="/teachers" element={<Teachers />} />
                                            <Route path="/users" element={<TeacherAssistantRestrictedRoute><Users /></TeacherAssistantRestrictedRoute>} />
                                            <Route path="/users/:userId/permissions" element={<TeacherAssistantRestrictedRoute><UserPermissions /></TeacherAssistantRestrictedRoute>} />
                                            <Route path="/attendance" element={<Attendance />} />
                                            <Route path="/payments" element={<Payments />} />
                                            <Route path="/activities" element={<Activities />} />
                                            <Route path="/notifications" element={<Notifications />} />
                                            <Route path="/reports" element={<Reports />} />
                                            <Route path="/staff-activity" element={<TeacherAssistantRestrictedRoute><StaffActivity /></TeacherAssistantRestrictedRoute>} />
                                            <Route path="/payroll" element={<AdminOnlyRoute><Payroll /></AdminOnlyRoute>} />
                                            <Route path="/my-payroll" element={<MyPayroll />} />
                                        </Routes>
                                    </Layout>
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </div>
            </ToastProvider>
        </AuthProvider>
    );
}

export default App;
